import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RutaService } from 'src/app/services/ruta.service';
import { SaldoDocumentoService } from 'src/app/services/saldo-documento.service';
import { TerritorioService } from 'src/app/services/territorio.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import * as _ from 'lodash'

@Component({
  selector: 'app-saldo-clientes',
  templateUrl: './saldo-clientes.component.html',
  styleUrls: ['./saldo-clientes.component.scss'],
  providers: [SecurityService],
})
export class SaldoClientesComponent implements OnInit {

  // Modales
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent

  // Form
  formHeader: FormGroup
  formHeaderDefaultValues: any

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  private currentPayload: any = null
  private inputParams: any = null
  clienteSeleccionado: any = null
  vendedorSeleccionado: any = null
  listaRegistros: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  enableClienteInputs: boolean = true

  optionsRutas: Array<any> = [];
  optionsTerritorio: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private rutaService: RutaService,
    private territorioService: TerritorioService,
    private saldoDocumentoService: SaldoDocumentoService
  ) {
    this.log = this.clog.log('CARTOLA-CLIENTE')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10

    this.loadRutas()
    this.loadTerritorios()

    this.createForms()
    this.formChangesSubscriptions()
  }

  loadRutas() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        tipobusqueda: 1
      }
    }
    this.rutaService.obtenerCombo(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsRutas = registros.map(estado => ({ value: estado.codigo, label: estado.descripcion, ...estado }))
    })
  }

  loadTerritorios() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        tipobusqueda: 1
      }
    }
    this.territorioService.obtenerCombo(inputParams, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsTerritorio = registros.map(estado => ({ value: estado.codigo, label: estado.descripcion, ...estado }))
    })
  }

  private createForms() {
    this.formHeader = this.fb.group({
      rutCliente: [''],
      todosClientes: [false],
      fechaDesde: [null, []],
      rutas: [[], []],
      territorios: [[], []],
      saldoDistintoCero: [false, []],
      sinClientesBloqueados: [false, []],
    });

    this.resetFormHeader()
  }

  resetFormHeader() {
    const now = this.datesService.CurrentDateToShortTimeString()

    this.formValidatorsService.reset(this.formHeader)

    this.formHeaderDefaultValues = {
      rutCliente: '',
      todosClientes: false,
      fechaDesde: now,
      rutas: [],
      territorios: [],
      saldoDistintoCero: true,
      sinClientesBloqueados: true,
    }

    this.setFormHeaderDefaultValues()
  }

  setFormHeaderDefaultValues() {
    this.formValidatorsService.setDefaultValues(this.formHeader, this.formHeaderDefaultValues)
  }

  private formChangesSubscriptions() {
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.log('rutCliente change', rutCliente)
        this.modalSeleccionarCliente.searchByRut(rutCliente)
      })

    /********* MODAL CLIENTE *********/
    this.formHeader.get("todosClientes").valueChanges
      .subscribe((todosClientes: string) => {
        this.enableClienteInputs = !todosClientes
      })
  }


  /********* MODAL CLIENTE *********/
  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data, origen }) {
    this.clienteSeleccionado = data
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut)
    this.log('this.clienteSeleccionado', this.clienteSeleccionado)
    this.formHeader.get('rutCliente').setValue(this.clienteSeleccionado.rutFormato)
  }

  onClienteNoEncontrado() {
    this.clienteSeleccionado = null
  }
  /********* MODAL CLIENTE *********/

  buscar(pageNumber: number) {
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.paginationContext.CurrentPage = pageNumber

    this.listaRegistros = []
    const inputParams = {
      entidad: {
        rut_emisor: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_emision: this.formHeader.get('fechaDesde').value,
        cliente_proveedor_rut: this.formHeader.get('todosClientes').value ? null : (this.clienteSeleccionado ? this.clienteSeleccionado.rut : null),
        todosClientes: this.formHeader.get('todosClientes').value,
        listaRutas: this.formHeader.get('rutas').value,
        listaTerritorio: this.formHeader.get('territorios').value,
        filtroMayo0: this.formHeader.get('saldoDistintoCero').value,
        filtroCliBoquedo: this.formHeader.get('sinClientesBloqueados').value,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.currentPayload = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.saldoDocumentoService.obtenerReporteSaldoClientes(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaRegistros = registros

      this.listaRegistros.map(registro => {
        registro.rutFormato = this.rutService.AgregarDV(registro.cliente_proveedor_rut)
      })

      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  downloadExcelPdf(type: 'XLS' | 'PDF') {
    const inputParams = _.cloneDeep(this.currentPayload)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    inputParams.entidad.retornaExcel = type === 'XLS'
    // inputParams.entidad.retornaPDF = type === 'PDF'

    this.log('inputParams', JSON.stringify(inputParams))

    this.saldoDocumentoService.obtenerReporteSaldoClientesExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta.registros[0].nombreArchivoExcel)
    })
  }

}
